export const BLOG_POST_HISTORY_ACTION = {
  TRANSLATED: "translated",
  OVERWRITTEN: "overwritten",
};

export const blogPostHistoryActionLabels = {
    [BLOG_POST_HISTORY_ACTION.TRANSLATED]: "Translated",
    [BLOG_POST_HISTORY_ACTION.OVERWRITTEN]: "Overwritten",
};
